import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";

import { Link, useNavigate, useParams } from "react-router-dom";
import { data } from "../../../Homepage/data";

import SectionContainer from "../../../Homepage/SectionContainer";
import Page8 from "../../../Homepage/Map";
import SmallPage from "../../../Homepage/SmallPage";

import FormClose from "../../../component/FormClose/FormClose";
import TimerModal from "../../../component/TimerModal/TimerModal";
import "../country.css";
import bond from "../../../assets/kangaroo/BondUniversity.png";
import arrow from "../../../assets/kangaroo/arrow-cropped.svg";
import charlesImg from "../../../assets/kangaroo/charlesdarwin.png";
import charlesSImg from "../../../assets/kangaroo/charlessturt.png";
import jamesImg from "../../../assets/kangaroo/jamescook.png";
import rmitImg from "../../../assets/kangaroo/rmit.png";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import Button from "../../../component/button/Button";
import "../../../component/Form/Form.css";
import Form from "../../../component/Form/Form";
import Map from "../../../Homepage/Map";
import InlineForm from "../../../component/InlineForm/InlineForm";
import Smallbutton from "../../../component/button/Smallbutton";
import MediumButton from "../../../component/button/MediumButton";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm";
const CountryPage = () => {
  const router = useNavigate();
  const { section } = useParams();
  const item = data[0][section];
  const [countryPage, setCountryPage] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const borderColor = "#dee2e6";
  const [thankYouModal, setThankYouModal] = useState(false);
  const toggleThankYou = () => setThankYouModal(!thankYouModal);
  useEffect(() => {
    setCountryPage(true);
    return () => {
      setCountryPage(false);
    };
  }, []);

  const InsImage = [
    { src: bond, alt: "Bond University" },
    { src: charlesImg, alt: "Charles Darwin University" },
    { src: charlesSImg, alt: "Charles Stut University" },
    { src: jamesImg, alt: "James University" },
    { src: rmitImg, alt: "RMIT University" },
    { src: bond, alt: "Bond University" },
    { src: charlesImg, alt: "Charles Darwin University" },
    { src: charlesSImg, alt: "Charles Stut University" },
    { src: jamesImg, alt: "James University" },
    { src: rmitImg, alt: "RMIT University" },
    { src: bond, alt: "Bond University" },
    { src: charlesImg, alt: "Charles Darwin University" },
    { src: charlesSImg, alt: "Charles Stut University" },
    { src: jamesImg, alt: "James University" },
    { src: rmitImg, alt: "RMIT University" },
    { src: bond, alt: "Bond University" },
    { src: charlesImg, alt: "Charles Darwin University" },
    { src: charlesSImg, alt: "Charles Stut University" },
    { src: jamesImg, alt: "James University" },
    { src: rmitImg, alt: "RMIT University" },
    { src: bond, alt: "Bond University" },
    { src: charlesImg, alt: "Charles Darwin University" },
    { src: charlesSImg, alt: "Charles Stut University" },
    { src: jamesImg, alt: "James University" },
    { src: rmitImg, alt: "RMIT University" },
  ];
  return (
    <>
      <div
        className="hero-banner"
        style={{ "--banner-img": `url(${item?.img})`, overflow: "hidden" }}
      >
        <SectionContainer className="d-flex align-items-center h-100">
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "SERVICES", link: "/services" },
              { title: "VISA & MIGRATION", },
            ]}
          />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1 className="banner-text-country lh-1">
              {" "}
              {`STUDY IN ${item?.title}`.toUpperCase()}
            </h1>
            <div onClick={toggleModal}>
              <MediumButton
                label="GET STARTED"
                fill="#d70a84"
                width={250}
                height={80}
                fontSize={24}
              />
            </div>
          </div>
        </SectionContainer>
      </div>
      <SectionContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Container fluid className="p-0">
            <Row>
              <Col>
                <div className="pe-lg-4">
                  <p className="country-desc-text ">{item.desc}</p>
                  {/* <img
            src={item.img}
            alt=""
            className="img-fluid w-100 rounded mt-3"
             style={{ width: "100%", height: "80vh", objectFit: "cover" }}
          /> */}

                  <div
                    className="ratio ratio-16x9 rounded p-0"
                    style={{ marginBottom: "5.2rem" }}
                  >
                    <iframe
                      src="https://www.youtube.com/embed/6z1gpw4CAAY?si=ftW22mDEl0Gd7bzy"
                      title="YouTube video"
                      allowFullScreen
                      className="rounded"
                    ></iframe>
                  </div>
                  <p
                    className="country-paragraph-text"
                    style={{ marginBottom: "5.2rem" }}
                  >
                    {item.content}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </SectionContainer>

      <SectionContainer mainId="Innerpage">
        <Row style={{marginTop:"6rem"}}> 
          <Col>
            <h1 className="font-heading">
              Start Smart with a Free Counseling Session
            </h1>
            <p className="font-desc mt-3 mb-4">
              Fill in the details below, and our counselors will reach out to
              guide you personally toward the right university and course in{" "}
              {item.title}.
            </p>
          </Col>
        </Row>

        <DynamicInlineForm
          fullName={true}
          emailAddress={true}
          phoneNumber={true}
          studyLevel={true}
          callBackTime={true}
          nearestOffice={true}
          message={true}
        />
        <div className="d-flex justify-content-end">
          <div
            style={{
              width: "max-content",
              marginTop: "4rem",
              marginBottom: "8rem",
            }}
            onClick={toggleThankYou}
          >
            <Button
              label="BOOK FREE COUNSELING"
              margin="20px 0"
              width="350.4053px"
              height="60px"
              fontSize="22px"
              fontWeight="500"
              textColor="#890295"
              fontFamily="Proxima Nova Bold"
            />
          </div>
        </div>
      </SectionContainer>

      <SectionContainer>
        <h1 className="font-level-8 " style={{ marginTop: "5.2rem" }}>
          Why Study in {item.title}
        </h1>
        <p className="country-paragraph-text">{item.why}</p>
        <h1 className="font-level-8 mt-5">Education in {item.title}</h1>
        <p className="country-paragraph-text">
          {item.Edu}{" "}
          <a href="#" className="country-custom-link">
            Explore Top 4 Universities in {item.title + " "}
            For Nepalese Students
          </a>
        </p>
        <h1 className="font-level-8 mt-5">How much will it cost?</h1>
        <p className="country-paragraph-text">
          {item.cost}
          <a href="#" className="country-custom-link">
            Read More About: Total cost to study in {item.title + " "}
            from Nepal
          </a>
        </p>
        <img
          src={item.people}
          alt=""
          className="img-fluid w-100 rounded h-100 mt-5 object-cover"
        />

        <h1 className="font-level-8 mt-5">
          Living in {item.title + " "}
          As Nepalese Student
        </h1>
        <p className="country-paragraph-text">{item.life}</p>
        <h1 className="font-level-8 mt-5">
          Working in {item.title + " "}
          As Nepalese Student
        </h1>
        <p className="country-paragraph-text" style={{ marginBottom: "15rem" }}>
          {" "}
          {item?.work}
          <a href="#" className="country-custom-link">
            Read In Detail About: Guide for International Students to Study In
            {" " + item.title}
          </a>
        </p>
        <hr className="line" />
        <Row>
          <Col>
            <p className="font-level-4 lh-1 mb-0 ">
              {" "}
              AUSTRALIAN INSTITUTIONS <br /> WE REPRESENT
            </p>
          </Col>
        </Row>

        <Row
          style={{
            marginTop: "61px",
            borderLeft: `1px solid ${borderColor}`,
          }}
          className="ms-2"
        >
          {InsImage.map((item, index) => (
            <Col
              key={index}
              xs={6}
              sm={6}
              md={3}
              lg={2}
              // ... rest of Col styles ...
              style={{
                borderRight: `1px solid ${borderColor}`,
                borderBottom: `1px solid ${borderColor}`,
                borderTop: `1px solid ${borderColor}`,
                cursor: "pointer",
              }}
              
              onClick={() => router("/studyabroad/institution")}
            >
              <img src={item.src} alt={item.alt} className="img-fluid" />
            </Col>
          ))}
        </Row>
        <Row>
          <Col className="d-flex justify-content-center align-items-center mt-5">
            <h1 className="button-font-Ins">LOAD MORE INSTITUTION</h1>
          </Col>
        </Row>
        <div className="d-flex justify-content-center align-items-center">
          <img src={arrow} className="rotate-90" alt="" />
        </div>

        <hr className="line" />
        <Map />
        <hr
          style={{
            border: 0,
            borderTop: "1.5px solid #5c5858",
            width: "99.7%",
            marginTop: "7.5rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />
        <FormClose
          modal={thankYouModal}
          toggle={toggleThankYou}
          heading="YOU'RE ONE STEP CLOSER TO STARTING SMART!"
          description="Our counselor will connect with you shortly."
        />
      </SectionContainer>
      <SectionContainer>
        <SmallPage countryPage={countryPage} />
      </SectionContainer>
      <Form
        modal={modalOpen}
        toggle={toggleModal}
        heading=" Get the Guidance you Need"
        description=" Share a few details and we’ll help you move forward with your study plans for this destination."
        additionalField={true}
        aus={true}
        closingMessage="YOU'RE ONE STEP CLOSER TO STARTING SMART"
        closingDesc="Our counselor will connect with you shortly"
      />
      <TimerModal />
    </>
  );
};

export default CountryPage;
